import { createSelector } from 'reselect';

const orderBuilder = state => state.modules.orderBuilder;

export const getCartStatus = createSelector(
  orderBuilder,
  state => state.cartStatus
);

export const getCartData = createSelector(
  orderBuilder,
  state => state.cartData
);

export const getParentCodesStatus = createSelector(
  orderBuilder,
  state => state.parentCodesStatus
);

export const getParentCodesData = createSelector(
  orderBuilder,
  state => state.parentCodesData
);